export default "__VITE_ASSET__B2wUIiz4__"